// extracted by mini-css-extract-plugin
export var box = "_4f-1";
export var checkboxRow = "_4f-8";
export var checked = "_4f-2";
export var descriptionSpacer = "_4f-a";
export var disabled = "_4f-3";
export var icon = "_4f-6";
export var input = "_4f-0";
export var labelSpacer = "_4f-9";
export var medium = "_4f-5";
export var small = "_4f-4";
export var text = "_4f-7";